import {
  LABEL_DATA_LOADING,
  LABEL_DATA_SUCCESS,
  LABEL_DATA_FAILURE,
  SET_LABEL,
  RESET_COUNT,
} from '../actions/labels';

const defaultState = {
  labels: [],
  loading: false,
  error: false,
  count: 0,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case LABEL_DATA_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case LABEL_DATA_SUCCESS:
      return {
        ...state,
        count: state.count + 1,
        loading: false,
        error: false,
      };
    case LABEL_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case SET_LABEL: {
      const { index, value } = action.payload;
      const labels = [...state.labels];
      labels[index] = value;
      return {
        ...state,
        labels,
      };
    }
    case RESET_COUNT:
      return {
        ...state,
        count: 0,
      };
    default:
      return state;
  }
};

export const loadingLabelDataSelector = (state) => state.labels.loading;
export const labelDataErrorSelector = (state) => state.labels.error;
export const labelsSelector = (state) => state.labels.labels;
export const countSelector = (state) => state.labels.count;
